import L from "leaflet";

export interface LocationMarkerData {
  lat: number;
  lng: number;
  accuracyMeters: number;
  capturedAt: Date | null;
}

const DEFAULT_CENTER: [number, number] = [35.681236, 139.767125]; // 東京駅(初期表示位置。データ受信後は上書きされる)
const DEFAULT_ZOOM = 15;

export class LocationMap {
  private map: L.Map;
  private marker: L.Marker | null = null;
  private accuracyCircle: L.Circle | null = null;

  constructor(containerId: string) {
    this.map = L.map(containerId).setView(DEFAULT_CENTER, DEFAULT_ZOOM);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(this.map);
  }

  /** マーカー・精度円・地図中心を更新する。 */
  update(data: LocationMarkerData): void {
    const latLng: [number, number] = [data.lat, data.lng];

    if (!this.marker) {
      this.marker = L.marker(latLng).addTo(this.map);
    } else {
      this.marker.setLatLng(latLng);
    }

    if (!this.accuracyCircle) {
      this.accuracyCircle = L.circle(latLng, {
        radius: data.accuracyMeters,
        color: "#3388ff",
        fillColor: "#3388ff",
        fillOpacity: 0.15,
      }).addTo(this.map);
    } else {
      this.accuracyCircle.setLatLng(latLng);
      this.accuracyCircle.setRadius(data.accuracyMeters);
    }

    const popupText = data.capturedAt
      ? `最終更新: ${data.capturedAt.toLocaleString("ja-JP")}\n精度: 約${Math.round(
          data.accuracyMeters,
        )}m`
      : `精度: 約${Math.round(data.accuracyMeters)}m`;
    this.marker.bindPopup(popupText.replace("\n", "<br>"));

    this.map.setView(latLng, this.map.getZoom() < DEFAULT_ZOOM ? DEFAULT_ZOOM : this.map.getZoom());
  }

  /** レイアウト変更後などにLeafletへ再描画を促す。 */
  invalidateSize(): void {
    this.map.invalidateSize();
  }
}
